import {merge} from 'rxjs';
import {map, scan, startWith} from 'rxjs/operators';
import {wsLogout$} from '@/user/auth-ws';
import {fiatAccountMsg$} from '@/raw/fiat-account';
import type {ReduceAction} from '@/types';

import FiatAccountMsg = fa.FiatAccountMsg;
import FiatAccountRaw = fa.FiatAccountRaw;
type Cache = Map<string, FiatAccountRaw>;
type Action = ReduceAction<Cache>;

const fiatAccountsData$ = fiatAccountMsg$.pipe(
  map((data: FiatAccountMsg) => data.payload),
  startWith([])
);

const action$ = fiatAccountsData$.pipe(
  map((fiatAccounts: FiatAccountRaw[]) => (cache: Cache) => {
    fiatAccounts.forEach((account) => cache.set(account.currency, account));
    return cache;
  })
);

const reset$ = wsLogout$.pipe(
  map(
    (): ReduceAction<Cache> => (cache: Cache) => {
      cache.clear();
      return cache;
    }
  )
);

export const fiatAccountCache$ = merge<Action[]>(action$, reset$).pipe(
  scan((p: Cache, c: Action) => c(p), new Map<string, FiatAccountMsg>())
);
